import React, { PureComponent } from "react";
import { createStyles, withStyles, WithStyles } from "@material-ui/core";
import { Grid, Theme } from "@material-ui/core";
import { StepStatus } from "./types/Stepper";
import clsx from "classnames";

const styles = (theme: Theme) =>
  createStyles({
    divider: {
      borderLeft: "2px solid #D2D2D2",
      width: "calc(100%-34px)",
    },
    activeDivider: {
      borderLeft: "2px solid #1D7DEA",
    },
  });

interface Props extends WithStyles<typeof styles> {
  disabledDivider?: boolean;
  dividerHeight?: string;
  dividerLeftShift?: string;
  dividerBorder?: string;
}

class MyPATStepper extends PureComponent<Props> {
  render() {
    const {
      children,
      classes,
      disabledDivider,
      dividerHeight,
      dividerLeftShift,
      dividerBorder,
    } = this.props;
    return (
      <Grid container>
        {React.Children.map(children, (child, i) => {
          const isFirstChild = i === 0;
          if(!child) return null;
          // @ts-ignore
          const status: StepStatus = child.props.status || StepStatus.PENDING;
          const isDividerActive =
            (status === StepStatus.DONE || status === StepStatus.INPROGRESS) &&
            !disabledDivider;
          return (
            <Grid container key={i}>
              {!isFirstChild && (
                <Grid
                  item
                  xs={12}
                  className={clsx(
                    classes.divider,
                    isDividerActive && classes.activeDivider
                  )}
                  style={{
                    marginLeft: dividerLeftShift || "34px",
                    height: dividerHeight || "24px",
                    border: dividerBorder || "none",
                  }}
                />
              )}
              <Grid item xs={12}>
                {child}
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    );
  }
}

// @ts-ignore
export default withStyles(styles)(MyPATStepper);
